export const SCHEDULING_MESSAGE = {
	TITLE: 'scheduling.drawer.title',
	TOGGLE_ON: 'scheduling.drawer.toggle_on',
	TOGGLE_OFF: 'scheduling.drawer.toggle_off',
	TOAST_ON: 'scheduling.drawer.toast_on',
	TOAST_OFF: 'scheduling.drawer.toast_off',
	SECTION: 'scheduling.drawer.section',
	ADD: 'scheduling.drawer.add',
	TIMEZONE_NOTE: 'scheduling.drawer.timezone_note',
	RUNS_IN: 'scheduling.drawer.runs_in',
	REMOVE: 'scheduling.drawer.remove',
	DAYS_GROUP: 'scheduling.drawer.days_group',
	ERROR_CONFLICT: 'scheduling.drawer.error_conflict',
	ERROR_NOT_FOUND: 'scheduling.drawer.error_not_found',
	ERROR_REFUSED: 'scheduling.drawer.error_refused',
} as const;
